"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiKey = exports.baseUrl = void 0;
exports.baseUrl = 'https://api.idle.finance/';
exports.apiKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6IkFwcDIiLCJpYXQiOjE2NzAyMzc1Mjd9.pf4YYdBf_Lf6P2_oKZ5r63UMd6R44p9h5ybPprtJmT4';
